import { createContext } from "react";

export interface IErrorMessageConfig {
  active?: boolean;
  message?: string;
  onSubmit?: () => void
}

export const ErrorMessageContext = createContext({
  messageConfig: {} as IErrorMessageConfig,
  setErrorMessage: (config: IErrorMessageConfig) => {}
});